import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormTitle from '../../../../library/form/components/FormTitle'
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColTwo } from "../../../../library/layout/Index";

const UserHeaderLimitedViewer = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null)

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='User Details' />
                    </span>
                </UiTitle>

                <UiAction>
                    <FormButton formObject={formObject} ksc="h" rowKey=""
                        starIcon={"edit"}
                        action={{ actionId: "edit",   containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="Edit" />}></FormButton>
                </UiAction>

            </UiViewHeading>
            <UiViewContent>
                <UiGridColTwo>
                    <div className="uiCol">
                        <ul>
                            <li>
                                <span className="uiLbl"><SarasTrans value = "User ID"/></span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "userId" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "title" }} value="Title" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "title" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "firstName" }} value="First Name" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "firstName" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "middleName" }} value="Middle Name" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "middleName" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "lastName" }} value="Last Name" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "lastName" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "svDepartment" }} value="Department" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "svDepartment" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "svLineHead" }} value="Line Head" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "svLineHead" }} className='uiVal' />

                            </li>
                        </ul>
                    </div>
                    <div className="uiCol">
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nickName" }} value="Nick Name" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "nickName" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "email1" }} value="Email 1" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "email1" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "mobile1" }} value="Mobile 1" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "mobile1" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "svLoginId" }} value="Login ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "svLoginId" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "language" }} value="Default Language" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "language" }} className='uiVal' />

                            </li>
                        </ul>
                    </div>
                </UiGridColTwo>
            </UiViewContent>
        </UiView>

    )
}

export default withView(UserHeaderLimitedViewer, "userHead", "userHead")